import { useState, useEffect } from 'react'
import { storage, theming } from '@carrent/platform'

/**
 * Тема оформления.
 *
 * По умолчанию светлая: основное визуальное направление — светлые
 * нейтральные фоны и белые поверхности. Тёмная включается атрибутом
 * data-theme="dark", под который написан блок переопределений в tokens.css.
 * (Прежний хук делал наоборот: дефолт dark и атрибут data-theme="light".)
 */
export function useTheme() {
  const [theme, setTheme] = useState(() => storage.getRaw('theme') || 'light')

  useEffect(() => {
    // Тема — свойство документа, а не компонента; в нативной сборке
    // этот вызов заменяется на смену темы контейнера.
    theming.applyTheme(theme)
    storage.setRaw('theme', theme)
  }, [theme])

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))
  return { theme, setTheme, toggle }
}
